import { createAction } from "typesafe-actions";
import { Material } from "./types";
import { SearchMode } from "../canvas/pages/teacher/search-tool/duck";

export const addMaterial = createAction("LTI/ADD_MATERIAL")<{
  material: Material;
}>();
export const removeMaterial = createAction("LTI/REMOVE_MATERIAL")<{
  id: string;
}>();
export const clearMaterials = createAction("LTI/CLEAR_MATERIALS")();
export const setSearchType = createAction("LTI/SET_SEARCH_TYPE")<SearchMode>();
